module.exports = __webpack_public_path__ + "img/Annotated_Throne_Of_Heaven_Map.782b702a.png";